import LocalStorage from './local-storage';
import { LANGUAGE, ES, EN, PT } from '../constants';
import ES_DIC from '../assets/translations/es.json';
import EN_DIC from '../assets/translations/en.json';
import PT_DIC from '../assets/translations/pt.json';

const getBrowserLanguage = () => {
    let browserLanguage = navigator.language || navigator.userLanguage; 
    if(!browserLanguage) return ES;

    const codeLanguage = browserLanguage.slice(0,2).toLowerCase();
    switch(codeLanguage) {
        case 'es':
            return ES;
        case 'en':
            return EN;
        case 'pt':
            return PT;
        default:
            return ES;
    }
}

const getText = (key) => {
    let defaultLanguage = LocalStorage.get(LANGUAGE);

    if (!defaultLanguage) {
        defaultLanguage = getBrowserLanguage();

        LocalStorage.set(LANGUAGE, defaultLanguage);
    }

    switch (defaultLanguage) {
        case ES:
            return ES_DIC[key] || key;
        case EN:
            return EN_DIC[key] || key;
        case PT:
            return PT_DIC[key] || key;

        default:
            return key;
    }
}

const TranslateService = {
    get: (key) =>  getText(key),
    getAndReplace: (key, params) => {
        let text = getText(key);

        const keys = Object.keys(params);
        for (const k of keys) {
            text = text.replace(`{${k}}`, params[k]);
        }

        return text;

    }
    // set: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
}

export default TranslateService;
